module.exports = __webpack_public_path__ + "static/SamTran-c44e7c76585957b0dd1158ee7c9f6ed8.jpeg";